import React, { useEffect, useRef } from 'react';
import './Vision.css';

const Vision = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          section.classList.add('vision-visible');
        } else {
          section.classList.remove('vision-visible');
        }
      },
      { threshold: 0.3 }
    );

    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section className="vision-section" ref={sectionRef}>
      <div className="vision-content">
        <h2>Our Vision</h2>
        <p>
          "To build a prosperous, inclusive, and sustainable community where every resident enjoys a high quality of life, empowered with opportunities for growth and development."
        </p>
      </div>
    </section>
  );
};

export default Vision;